import { CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { CustomButton } from "../../ui/CustomButton";
import { useState } from "react";
import { StarsOutlineIcon } from "../../images";
import { ReuseInput } from "../../ui";

type Props = {
  title: string;
  subtitle: string;
  submitHandler: (text: string) => Promise<void>;
  isLoading: boolean;
  placeholder: string;
};

export const AiAssistantBlock = ({
  title,
  subtitle,
  submitHandler,
  isLoading,
  placeholder,
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [text, setText] = useState<string>("");

  const openHandler = () => setIsOpen(true);
  const closeHandler = () => {
    setIsOpen(false);
    setText("");
  };

  const inputChange = (_: string, value: string) => {
    setText(value);
  };

  const onSubmit = async () => {
    await submitHandler(text);
    setIsOpen(false);
    setText("");
  };

  return (
    <>
      <Stack
        flexDirection={"row"}
        gap={"16px"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Stack gap={"16px"}>
          <Stack gap={"8px"}>
            <Typography
              variant="subtitle1"
              color="custom.textDarkBlue"
              fontWeight={500}
            >
              {title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {subtitle}
            </Typography>
          </Stack>
          {isOpen && (
            <>
              <ReuseInput
                value={text}
                errorMessage={""}
                label={""}
                name={"AI assistant"}
                placeholder={placeholder}
                handleInputChange={inputChange}
                isError={false}
                setErrorHandler={() => {}}
                multiline
                maxRows={3}
                withResize={false}
              />
              <Stack direction="row" gap="8px">
                <CustomButton
                  variant="contained"
                  textColor="#4C545B"
                  type="button"
                  customColor="#F1F1F1"
                  onClick={closeHandler}
                  fullWidth
                  sx={{ height: "36px" }}
                  disabled={isLoading}
                >
                  Cancel
                </CustomButton>
                <CustomButton
                  variant="outlined"
                  customColor="#FFFFFF"
                  textColor="#FE8836"
                  type="button"
                  fullWidth
                  sx={{ borderColor: "#FE8836", height: "36px" }}
                  onClick={onSubmit}
                  disabled={!text || isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={20} color={"inherit"} />
                    ) : (
                      <StarsOutlineIcon color={text ? undefined : "#9B9B9B"} />
                    )
                  }
                >
                  Analyze
                </CustomButton>
              </Stack>
            </>
          )}
        </Stack>
        {!isOpen && (
          <CustomButton
            variant="outlined"
            customColor="#FFFFFF"
            textColor="#FE8836"
            customSize="fit"
            type="button"
            sx={{ height: "36px", borderColor: "#FE8836", padding: "3px 15px" }}
            onClick={openHandler}
          >
            Add Details
          </CustomButton>
        )}
      </Stack>
      <Divider sx={{ width: "100%" }} />
    </>
  );
};
